import { useCallback, useState } from 'react'
import type { MarkerSelectionData } from 'tripPlanner/components/Chat/chatMapConstants'

export type RightPanelView = 'map' | 'itinerary'

interface UseRightPanelStateReturn {
  rightPanelView: RightPanelView
  setRightPanelView: React.Dispatch<React.SetStateAction<RightPanelView>>
  selectedDayItineraryId: number | undefined
  setSelectedDayItineraryId: React.Dispatch<React.SetStateAction<number | undefined>>
  selectedMarkerData: MarkerSelectionData | undefined
  handleMarkerSelect: (data: MarkerSelectionData | undefined) => void
  handleMarkerOverlayClose: () => void
}

export function useRightPanelState(): UseRightPanelStateReturn {
  const [rightPanelView, setRightPanelView] = useState<RightPanelView>('map')
  const [selectedDayItineraryId, setSelectedDayItineraryId] = useState<number | undefined>(undefined)
  const [selectedMarkerData, setSelectedMarkerData] = useState<MarkerSelectionData | undefined>(undefined)

  const handleMarkerSelect = useCallback((data: MarkerSelectionData | undefined) => {
    setSelectedMarkerData(data)
  }, [])

  const handleMarkerOverlayClose = useCallback(() => {
    setSelectedMarkerData(undefined)
  }, [])

  return {
    rightPanelView,
    setRightPanelView,
    selectedDayItineraryId,
    setSelectedDayItineraryId,
    selectedMarkerData,
    handleMarkerSelect,
    handleMarkerOverlayClose,
  }
}
